import { useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import ConfirmModalHook from '@/components/common/ConfirmModal/ConfirmModal.hook'
import { ClaimStatusCodeEnum } from '../../HealthClaimPage/ClaimHandlingTable/types'
import { useUpdateClaimStatus } from '@/services/healthClaim/useUpdateClaimStatus'
import message from '@/libs/message'
import { useQueryClient } from '@tanstack/react-query'

const ApproveButtonHook = () => {
  const { claimFormId } = useParams<{ claimFormId?: string }>()
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const { setConfirmModal } = ConfirmModalHook()
  const { mutateAsync: updateClaimStatus } = useUpdateClaimStatus()

  const queryClient = useQueryClient()

  const isHideButton = !(
    claimFormId &&
    healthClaim.data?.statusCode === ClaimStatusCodeEnum.PENDING_APPROVAL &&
    !healthClaim.data?.savePvAction
  )

  // Modal confirm approve
  const showApproveModal = () => {
    if (!claimFormId) return

    setConfirmModal({
      isVisible: true,
      title: 'ยืนยันอนุมัติจ่ายค่าสินไหมทดแทน',
      bodyText: 'คุณได้ตรวจสอบข้อมูลว่าถูกต้องครบถ้วนแล้ว',
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      dataTestId: 'approve-confirm-information-modal',
      onOkFunction: async () => {
        try {
          await updateClaimStatus({ claimFormId, claimStatus: ClaimStatusCodeEnum.APPROVED }).then(
            () => {
              // Ensure detail is fresh when navigating
              queryClient.refetchQueries({
                queryKey: ['useGetClaimDetail', healthClaim.data?.claimFormId],
              })
            },
          )
          message.success({ content: 'อนุมัติสำเร็จ', duration: 10 })
        } catch (error: any) {
          message.error({
            content: 'ส่งข้อมูลไม่สำเร็จ',
            duration: 10,
          })
        } finally {
          setConfirmModal({
            isVisible: false,
            onOkFunction: Function,
          })
        }
      },
    })
  }

  const handleClickApprove = () => {
    showApproveModal()
  }

  return { handleClickApprove, isHideButton }
}

export default ApproveButtonHook
